<template>
  <div class="form-group">
    <div class="input-group">
      <label
        v-if="label"
        style="margin-bottom: 0.5rem !important"
      >
        {{ label }}
      </label>
      <datepicker
        ref="programaticOpen"
        v-model="customModel"
        :language="fr"
        :use-utc="true"
        :monday-first="true"
        :disabled="inputDisabled"
        format="dd/MM/yyyy"
        :disabled-dates="disabledDates"
        :bootstrap-styling="true"
        :input-class="inputDisabled ? 'input-date' : 'input-date bg-white'"
        wrapper-class="w-100"
        calendar-class="rounded-4 w-100 my-2 animated"
      />
    </div>
  </div>
</template>
<script>
import { en, fr } from 'vuejs-datepicker/dist/locale';

import Datepicker from 'vuejs-datepicker';
import input from '@/mixins/input-2';

export default {
  name: 'InputDate',
  components: {
    datepicker: Datepicker,
  },
  mixins: [input],
  props: {
    disabledDates: {
      type: [Object, Array, Date],
      default: () => ({
        to: ((d) => new Date(d.setDate(d.getDate() - 1)))(new Date()),
        days: [],
      }),
    },
  },
  data() {
    return {
      inline: true,
      fr,
      en,
    };
  },
  computed: {
    customModel: {
      get() {
        return this.customValue;
      },
      set(value) {
        return this.$store.dispatch(
          this.setterPath,
          this.setterFunction(value, this.path || this.getterName),
        );
      },
    },
  },
  methods: {
    openPicker() {
      this.$refs.programaticOpen.showCalendar();
    },
  },
};
</script>
<style>
.vdp-datepicker__calendar .cell.selected {
  background-color: var(--bs-primary);
  color: white;
}
.vdp-datepicker__calendar header .prev:not(.disabled) {
  border-top-left-radius: 20px;
}
.vdp-datepicker__calendar header .next:not(.disabled) {
  border-top-right-radius: 20px;
}
</style>
<style scoped>
.animated {
  transition: 1s all;
}
</style>
